__turbopack_context__.v({
  "body_rich_text": "Form-module-scss-module__av_ehG__body_rich_text",
  "direction__column": "Form-module-scss-module__av_ehG__direction__column",
  "direction__row": "Form-module-scss-module__av_ehG__direction__row",
  "form-heading-block": "Form-module-scss-module__av_ehG__form-heading-block",
  "gradient-glow-blue": "Form-module-scss-module__av_ehG__gradient-glow-blue",
  "gradient-glow-neon": "Form-module-scss-module__av_ehG__gradient-glow-neon",
  "gradient-glow-orange": "Form-module-scss-module__av_ehG__gradient-glow-orange",
  "gradient-glow-pink": "Form-module-scss-module__av_ehG__gradient-glow-pink",
  "gradient-glow-snap-pea": "Form-module-scss-module__av_ehG__gradient-glow-snap-pea",
  "gradient-neon-pink": "Form-module-scss-module__av_ehG__gradient-neon-pink",
  "gradient-pink-blue": "Form-module-scss-module__av_ehG__gradient-pink-blue",
  "gradient-pink-orange": "Form-module-scss-module__av_ehG__gradient-pink-orange",
  "layout__content-leading": "Form-module-scss-module__av_ehG__layout__content-leading",
  "layout__content-trailing": "Form-module-scss-module__av_ehG__layout__content-trailing",
  "module-base": "Form-module-scss-module__av_ehG__module-base",
  "module-content-swap": "Form-module-scss-module__av_ehG__module-content-swap",
  "module_block__contained": "Form-module-scss-module__av_ehG__module_block__contained",
  "module_block__uncontained": "Form-module-scss-module__av_ehG__module_block__uncontained",
  "module_breadcrumbs": "Form-module-scss-module__av_ehG__module_breadcrumbs",
  "section_bg_fill__base": "Form-module-scss-module__av_ehG__section_bg_fill__base",
  "section_bg_fill__gradient": "Form-module-scss-module__av_ehG__section_bg_fill__gradient",
  "section_bg_fill__no-fill": "Form-module-scss-module__av_ehG__section_bg_fill__no-fill",
  "section_bg_fill__raised": "Form-module-scss-module__av_ehG__section_bg_fill__raised",
  "section_container": "Form-module-scss-module__av_ehG__section_container",
  "with_breadcrumb": "Form-module-scss-module__av_ehG__with_breadcrumb",
  "with_navbar": "Form-module-scss-module__av_ehG__with_navbar",
});
